import { FieldError, FieldErrors } from "react-hook-form";
import { ContactProgress, SLPParticipation } from "utils/enums/slp";
import { AchievementRatingGAS, SLPFormStep } from "utils/enums/slp-form";
import {
  getBaselineLevelError,
  getSmartGoalError,
  getStudentGoalError,
} from "utils/helper/validation-message-helper";
import { ISLPRequestsFilter } from "utils/interfaces/slp";

export const SLP_CONTACT_PROGRESS = [
  { value: ContactProgress.NotStarted, label: "Not Started" },
  { value: ContactProgress.InProgress, label: "In Progress" },
  { value: ContactProgress.Assigned, label: "Assigned" },
];

export const SLP_PARTICIPATION = [
  { value: SLPParticipation.Active, label: "Active" },
  {
    value: SLPParticipation.NoFurtherSLPRequired,
    label: "No Further SLP Required",
  },
];

export const DEFAULT_SLP_REQUESTS_FILTER: ISLPRequestsFilter = {
  slpParticipation: [SLPParticipation.Active],
  allocatedTo: [],
  from: null,
  numberOfCompletedSLP: null,
  to: null,
};

export const SCALE_OPTIONS = [1, 2, 3];

export const ratingDisplayMap: Record<AchievementRatingGAS, string> = {
  [AchievementRatingGAS.Worse]: "Worse",
  [AchievementRatingGAS.SameAsBaseline]: "Same as baseline",
  [AchievementRatingGAS.PartiallyAchieved]: "Partially achieved",
  [AchievementRatingGAS.AsExpected]: "As expected",
  [AchievementRatingGAS.ALittleBetter]: "A little better",
  [AchievementRatingGAS.MuchBetter]: "Much better",
};

export const PERSONAL_SMART_GOALS_MAX_LENGTH = 500;
export const VARIANCE_MAX_LENGTH = 250;

export const MODAL_TYPES = {
  ASSESS: "assess",
  DELETE: "delete",
};

export const goalsTextFieldConfigs = (errors: FieldErrors) => [
  {
    name: "studentGoals",
    label: "Student Goal",
    error: errors.studentGoals,
    helper: getStudentGoalError(errors.studentGoals as FieldError | undefined),
  },
  {
    name: "smartGoals",
    label: "Smart Goal",
    error: errors.smartGoals,
    helper: getSmartGoalError(errors.smartGoals as FieldError | undefined),
  },
  {
    name: "baselineLevel",
    label: "Baseline Level",
    error: errors.baselineLevel,
    helper: getBaselineLevelError(
      errors.baselineLevel as FieldError | undefined
    ),
  },
];

export const steps = [
  SLPFormStep.HOPES_GOALS_AMBITIONS,
  SLPFormStep.PERSONAL_SMART_GOALS,
  SLPFormStep.WHERE_TO_FROM_HERE,
];

export type TableCellAlign = "left" | "center" | "right";

export const SLPGoalsTableColumns = (showAssessedColumn: boolean) => [
  {
    key: "assess",
    label: "Assessed",
    width: 92,
    align: "center",
    hidden: !showAssessedColumn,
  },
  {
    key: "slpNumber",
    label: "SLP Number",
    width: 84,
    minWidth: 84,
    align: "center",
    hidden: !showAssessedColumn,
  },
  { key: "studentGoals", label: "Student Goal", width: 250, minWidth: 200 },
  { key: "smartGoals", label: "Smart Goal", width: 250, minWidth: 200 },
  {
    key: "importance",
    label: "Importance",
    width: 100,
    minWidth: 100,
    align: "center",
  },
  {
    key: "difficulty",
    label: "Difficulty",
    width: 100,
    minWidth: 100,
    align: "center",
  },
  {
    key: "goalWeight",
    label: "Goal Weight",
    width: 84,
    minWidth: 84,
    align: "center",
  },
  {
    key: "baselineLevel",
    label: "Baseline Level",
    width: 250,
    minWidth: 200,
  },
  {
    key: "achievementRatings",
    label: "Achievement Ratings",
    width: 200,
    minWidth: 200,
  },
  { key: "variance", label: "Variance", width: 250, minWidth: 200 },
  {
    key: "slpGoalDate",
    label: "SLP Date",
    width: 130,
    minWidth: 130,
    hidden: !showAssessedColumn,
  },
  {
    key: "goalAssessedDate",
    label: "Goal Assessed",
    width: 120,
    minWidth: 120,
    hidden: !showAssessedColumn,
  },
  {
    key: "actions",
    label: "Action",
    width: 92,
    align: "center",
    // hidden: showAssessedColumn,
  },
];
